export default {
  inviteOnly: false,
};
